export default __webpack_public_path__ + "static/media/licenses-background.767a8c56.png";